// @flow

import * as React from 'react'
import { connect } from 'react-redux'
import Spinner from 'frame/ui/Spinner'

function mapStateToProps (state) {
  return {
    visitor: state.vars.visitor
  }
}

export default function (Comp: React.ComponentType<*>) {
  function RequireLoginComp (props) {
    let { visitor } = props
    return visitor ? <Comp {...props} /> : <Spinner />
  }

  return connect(mapStateToProps)(RequireLoginComp)
}



// WEBPACK FOOTER //
// ./src/projects/fengjr/hoc/requireVisitor.js